module.exports = "/images/th.svg";